
    import { Mapper } from "../../../../base/utils/mapper";
    import { AffectedAreaPhysiotherapyModel } from "../../../../domain/models/consult/affected-area-physiotherapy.model";
    import { AffectedAreaPhysiotherapyEntity } from "../entities/affected-area-physiotherapy.entity";
        export class AffectedAreaPhysiotherapyImplementationRepositoryMapper extends Mapper<AffectedAreaPhysiotherapyEntity, AffectedAreaPhysiotherapyModel>{
            mapFrom(param:  AffectedAreaPhysiotherapyEntity):  AffectedAreaPhysiotherapyModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  AffectedAreaPhysiotherapyModel):  AffectedAreaPhysiotherapyEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }